import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgItalic = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 10" {...props}>
    <path
      fill="#17181A"
      fillRule="evenodd"
      d="M1.498 10H.336L2.394.662h1.162z"
    />
  </svg>
);
const Memo = memo(SvgItalic);
export default Memo;
